import { FormContainer } from "@/components/form/form-container";
import { useForm } from "react-hook-form";
import { Anchor } from "@/components/ui/anchor";
import { SubmitButton } from "@/components/ui/button";
import { MasterParamFormFields } from "./MasterParamFormFields";
import {
  masterParamPayloadSchema,
  MasterParamPayloadSchema,
  useMasterParamCreate,
} from "@/api/master-param";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { AxiosError } from "axios";

export function MasterParamCreateForm() {
  const form = useForm<MasterParamPayloadSchema>({
    resolver: zodResolver(masterParamPayloadSchema),
  });

  const { mutate, isPending } = useMasterParamCreate();
  const navigate = useNavigate();

  function handleSubmit(values: MasterParamPayloadSchema) {
    if (values.active === "true") {
      values.active = true;
    } else {
      values.active = false;
    }

    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "Master Param has been created",
            })
            .then(() => navigate("/master-data/master-param"));
        },
        onError: (error: Error) => {
          const err = error as AxiosError;
          const errorMessage = (err.response?.data as { data: unknown })?.data;

          swalError.fire({
            text: `${errorMessage}`,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <MasterParamFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor href="/master-data/master-param" mood="axiata-blue-outline">
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
